/**
 * 历史导入试卷记录
 * @Author:3173
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, utils_tool, component_tool } from '@/tool'
import { modelUtils } from "@/utils";
import { WizTableForm } from '../../common'

let {
  WizContainer, ossFileUtils
} = framework_tool;

class ExportFileList extends WizContainer {
  componentName = 'exportFileList';

  constructor(props) {
    super(props);
    this.state = {
      value: undefined,
    };
  }

  _componentDidMount = () => {

  }

  /**
    * 获取 blob
    *   {String} url 目标文件地址
    *  {cb} 下载完的保存回调
    */
  getBlob(url, cb) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (xhr.status === 200) {
        cb(xhr.response);
      }
    };
    xhr.send();
  }

  /**
   * 保存
   *   {Blob} blob
   *   {String} filename 想要保存的文件名称
   */
  saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement('a');
      let body = document.querySelector('body');

      link.href = window.URL.createObjectURL(blob);
      link.download = filename;

      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);

      link.click();
      body.removeChild(link);

      window.URL.revokeObjectURL(link.href);
    };
  }


  downloadFile(obj, e) {
    let { value } = this.state;
    if (value && value instanceof Array) {
      value.forEach(data => {
        if (data.fileUri && data.fileId) {
          //let ossFile = ossFileUtils.getOssFile(data.fileId, data.fileName, data.fileMimeType, data.fileSize, data.fileUri);
          let url = getOssFilePath(data.fileId)
          // const a = document.createElement('a')
          // a.setAttribute('download', ossFile.fileOriginalName)
          // a.setAttribute('href', ossFile.url)
          // a.click()
          this.getBlob(url, (blob) => {
            this.saveAs(blob, data.fileName);
          });
        }
      })
    }
    this.props.changeModal(false);
  }

  setFileData(nextKeys, nextRows) {
    this.setState({
      value: nextRows
    })
  }

  _render() {
    let { record,key } = this.props;

    let columns = [
      {
        title: "导出文件名称",
        name: "fileName",
        tableItem: {},
      },
      {
        title: "上传时间",
        name: "createTime",
        tableItem: {},
      },
      {
        title: "版本序号",
        name: "version",
        tableItem: {},
      },
      {
        name: "fileUri",
        formItem: {
          type: "hidden"
        }
      }
    ]

    return <WizTableForm
      key={key }
      rowkey='fileId' rowName='fileName'
      title={'选择考卷'}
      selectType={'radio'}
      showModal={false}
      tableApi={{
        path: 'fileRemoteAuthRelation/listByPage',
        apiParams: {
          remoteAuthId: record.id,
        },
        key:'fileRemoteAuthRelation'+record.id
      }}
      columns={columns}
      renderValue={this.setFileData.bind(this)}
    />
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(ExportFileList);
